// The experiment group comes from the entry link's "group" URL parameter
// (e.g. /?qualtrics_id=...&prolific_id=...&group=2) and is stored on the
// participant in the backend (user_group). It is saved at entry so every
// store page can read it; anything missing or other than 0-3 means group 0.
const GROUP_STORAGE_KEY = "store_group";
const PROLIFIC_STORAGE_KEY = "store_prolific_id";
const VALID_GROUPS = ["0", "1", "2", "3"];

// Qualtrics response IDs (R_xxx) and Prolific IDs (24 hex chars) both fit this.
export const PARTICIPANT_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

export function parseGroup(value) {
  const trimmed = (value || "").trim();
  return VALID_GROUPS.includes(trimmed) ? Number(trimmed) : 0;
}

export function saveUserGroup(group) {
  try {
    localStorage.setItem(GROUP_STORAGE_KEY, String(group));
  } catch (e) {}
}

export function saveProlificId(prolificId) {
  try {
    localStorage.setItem(PROLIFIC_STORAGE_KEY, prolificId);
  } catch (e) {}
}

export function getProlificId() {
  try {
    return localStorage.getItem(PROLIFIC_STORAGE_KEY) || "";
  } catch (e) {
    return "";
  }
}

export function getUserGroup() {
  try {
    return parseGroup(localStorage.getItem(GROUP_STORAGE_KEY));
  } catch (e) {
    return 0;
  }
}

// G1 and G3 both use the muted-green theme (#67976A) instead of the
// default yellow; only the tagline text differs between them.
export function isGreenTheme(group) {
  return group === 1 || group === 3;
}

// Sustainability/nutrition label badges on the product page are shown only
// to G1 and G3; G0 and G2 see the product without labels.
export function showsLabels(group) {
  return group === 1 || group === 3;
}

// Where "Return to Qualtrics" sends the participant after checkout, with
// qualtrics_id, prolific_id and group appended. `returnUrl` comes from the
// server's QUALTRICS_RETURN_URL setting; when empty it falls back to /done.
export function buildQualtricsReturnUrl(qualtricsId, returnUrl) {
  const base = returnUrl || "/done";
  const params = new URLSearchParams({
    qualtrics_id: qualtricsId,
    prolific_id: getProlificId(),
    group: String(getUserGroup()),
  });
  return `${base}${base.includes("?") ? "&" : "?"}${params.toString()}`;
}
